import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import HelpPopover from '../helpPopover/helpPopover'

//styling
import "./mainContent.scss";


const MainContent = ({ children }) => {
  return (
    <div className="main-container">
      <Navbar bg="white">
        <Container className="d-flex justify-content-between px-5">
          <div></div>
         <HelpPopover/>
        </Container>
      </Navbar>
      <div className="w-100 p-4 px-4">{children}</div>
    </div>
  );
};

export default MainContent;
